<template>
  <div class="account-warpper">
    <div class="bg-white ">

      <h1  class="font-size-lg" style="color: #f3b861">积分获取比例设置</h1>
      <el-row :gutter="20">
        <el-col :span="12">
          <h3 class="margin-top margin-bottom-sm">志愿者队长</h3>

          <div class="flex align-center justify-between">
            <el-input placeholder="请输入" v-model="num1" type="number">
              <template slot="prepend">积分比例:</template>
            </el-input>
            <!--        <el-input placeholder="请输入" v-model="num2" type="number" class="margin-lr">-->
            <!--          <template slot="prepend">金暖宝比例:</template>-->
            <!--        </el-input>-->
            <!--        <el-input placeholder="请输入" v-model="num3" type="number">-->
            <!--          <template slot="prepend">银暖宝比例:</template>-->
            <!--        </el-input>-->
          </div>
        </el-col>
        <el-col :span="12">
                <h3 class="margin-top margin-bottom-sm">志愿者</h3>
                <div class="flex align-center justify-between">
                  <el-input placeholder="请输入" v-model="num4" type="number">
                    <template slot="prepend">积分比例:</template>
                  </el-input>
<!--                  <el-input placeholder="请输入" v-model="num5" type="number" class="margin-lr">-->
<!--                    <template slot="prepend">金暖宝比例:</template>-->
<!--                  </el-input>-->
<!--                  <el-input placeholder="请输入" v-model="num6" type="number">-->
<!--                    <template slot="prepend">银暖宝比例:</template>-->
<!--                  </el-input>-->
                </div>
        </el-col>
        <el-col :span="12">
          <h3 class="margin-top margin-bottom-sm">志愿者(楼门长)</h3>
          <div class="flex align-center justify-between">
            <el-input placeholder="请输入" v-model="num7" type="number">
              <template slot="prepend">积分比例:</template>
            </el-input>
            <!--        <el-input placeholder="请输入" v-model="num8" type="number" class="margin-lr">-->
            <!--          <template slot="prepend">金暖宝比例:</template>-->
            <!--        </el-input>-->
            <!--        <el-input placeholder="请输入" v-model="num9" type="number">-->
            <!--          <template slot="prepend">银暖宝比例:</template>-->
            <!--        </el-input>-->
          </div>
        </el-col>
        <el-col :span="12">
          <h3 class="margin-top margin-bottom-sm">志愿者(物业员工)</h3>
          <div class="flex align-center justify-between">
            <el-input placeholder="请输入" v-model="num10" type="number">
              <template slot="prepend">积分比例:</template>
            </el-input>
            <!--        <el-input placeholder="请输入" v-model="num11" type="number" class="margin-lr">-->
            <!--          <template slot="prepend">金暖宝比例:</template>-->
            <!--        </el-input>-->
            <!--        <el-input placeholder="请输入" v-model="num12" type="number">-->
            <!--          <template slot="prepend">银暖宝比例:</template>-->
            <!--        </el-input>-->
          </div>
        </el-col>
        <el-col :span="12">
          <h3 class="margin-top margin-bottom-sm">志愿者(居民)</h3>
          <div class="flex align-center justify-between">
            <el-input placeholder="请输入" v-model="num13" type="number">
              <template slot="prepend">积分比例:</template>
            </el-input>
            <!--        <el-input placeholder="请输入" v-model="num14" type="number" class="margin-lr">-->
            <!--          <template slot="prepend">金暖宝比例:</template>-->
            <!--        </el-input>-->
            <!--        <el-input placeholder="请输入" v-model="num15" type="number">-->
            <!--          <template slot="prepend">银暖宝比例:</template>-->
            <!--        </el-input>-->
          </div>
        </el-col>
        <el-col :span="12">
          <h3 class="margin-top margin-bottom-sm">志愿者(社会组织)</h3>
          <div class="flex align-center justify-between">
            <el-input placeholder="请输入" v-model="num16" type="number">
              <template slot="prepend">积分比例:</template>
            </el-input>
            <!--        <el-input placeholder="请输入" v-model="num17" type="number" class="margin-lr">-->
            <!--          <template slot="prepend">金暖宝比例:</template>-->
            <!--        </el-input>-->
            <!--        <el-input placeholder="请输入" v-model="num18" type="number">-->
            <!--          <template slot="prepend">银暖宝比例:</template>-->
            <!--        </el-input>-->
          </div>
        </el-col>



      </el-row>

      <h3 class="margin-tb">评价结算比例</h3>
      <div class="flex align-center justify-between">
        <el-input placeholder="请输入" v-model="num20" type="number">
          <template slot="prepend">非常满意比例:</template>
          <template slot="append">%</template>
        </el-input>
        <el-input placeholder="请输入" v-model="num21" type="number" class="margin-lr">
          <template slot="prepend">满意比例:</template>
          <template slot="append">%</template>
        </el-input>
        <el-input placeholder="请输入" v-model="num22" type="number" class="margin-right-sm">
          <template slot="prepend">一般比例:</template>
          <template slot="append">%</template>
        </el-input>
        <el-input placeholder="请输入" v-model="num23" type="number">
          <template slot="prepend">不满意比例:</template>
          <template slot="append">%</template>
        </el-input>
      </div>



      <h1  class="font-size-lg margin-tb-lg" style="color: #f3b861">现金购买积分比例设置</h1>

      <el-row :gutter="20">
        <el-col :span="12">
          <div class="flex align-center justify-between">
            <el-input  value="1" type="append" disabled>
              <template slot="append">积分</template>
            </el-input>
             <span class="padding-lr">=</span>
            <el-input placeholder="请输入" v-model="num19" type="number">
              <template slot="append">元</template>
            </el-input>
          </div>
        </el-col>
      </el-row>
      <div class="flex align-center justify-around margin-top">
        <el-button type="primary" @click="setNum" style="width: 200px;">保存</el-button>
      </div>

    </div>
  </div>
</template>

<script>

import {getInregralLv, updateInregralLv} from "@/api/weilao";

export default {
  name: "calculation",
  data() {
    return {
      num1: 0,
      num2: 0,
      num3: 0,
      num4: 0,
      num5: 0,
      num6: 0,
      num7: 0,
      num8: 0,
      num9: 0,
      num10: 0,
      num11: 0,
      num12: 0,
      num13: 0,
      num14: 0,
      num15: 0,
      num16: 0,
      num17: 0,
      num18: 0,
      num19: 0,
      num20: 100,
      num21: 75,
      num22: 50,
      num23: 0,
    }
  },
  created() {
    this.$emit("setIndex", this.$route.path, "双暖为老 / 积分设置", false);
    this.getNum()
  },
  computed: {
    user() {
      return this.$store.state.user
    }
  },
  components: {},
  methods: {
    async getNum() {
      const res = await getInregralLv()
      this.num1 = res.data.wygj_integral
      this.num2 = res.data.wygj_jinnuanbao
      this.num3 = res.data.wygj_yinnuanbao
      this.num4 = res.data.sndy_integral
      this.num5 = res.data.sndy_jinnuanbao
      this.num6 = res.data.sndy_yinnuanbao
      this.num7 = res.data.lmz_integral
      this.num8 = res.data.lmz_jinnuanbao
      this.num9 = res.data.lmz_yinnuanbao
      this.num10 = res.data.wyyg_integral
      this.num11 = res.data.wyyg_jinnuanbao
      this.num12 = res.data.wyyg_yinnuanbao
      this.num13 = res.data.jm_integral
      this.num14 = res.data.jm_jinnuanbao
      this.num15 = res.data.jm_yinnuanbao
      this.num16 = res.data.shzz_integral
      this.num17 = res.data.shzz_jinnuanbao
      this.num18 = res.data.shzz_yinnuanbao
      this.num19 = res.data.integral_lv
      this.num20 = res.data.fcmy_lv
      this.num21 = res.data.my_lv
      this.num22 = res.data.yb_lv
      this.num23 = res.data.bmy_lv
    },
    async setNum() {
      await updateInregralLv(
        this.num1,
        this.num2,
        this.num3,
        this.num4,
        this.num5,
        this.num6,
        this.num7,
        this.num8,
        this.num9,
        this.num10,
        this.num11,
        this.num12,
        this.num13,
        this.num14,
        this.num15,
        this.num16,
        this.num17,
        this.num18,
        this.num19,
        this.num20,
        this.num21,
        this.num22,
        this.num23
      )
      this.$message.success('设置成功')
      await this.getNum()
    }
  },
  filters: {},
  watch: {},
}
</script>

<style scoped lang="scss">

</style>
